import type React from 'react';
import AttachFileIcon from '../../../ui/new-assets/attach_file.svg';
import BreakingNewsIcon from '../../../ui/new-assets/breaking_news.svg';
import ConstructionIcon from '../../../ui/new-assets/construction.svg';
import InfoIcon from '../../../ui/new-assets/info.svg';
import type { ITranslationFunction } from '../../shared/i18n/translate';
import { Color } from '../../shared/styles/Color';

interface INewsroomUrls {
	aviationDepartment: string;
	stayConnected: string;
	mediaLibrary: string;
	constructionProjects: string;
}
export const getNewsroomShortcuts = (
	t: ITranslationFunction,
	urls: INewsroomUrls,
) => [
	{
		title: t('entry_point_label_aviation_department'),
		href: urls.aviationDepartment,
		color: Color.SecondaryDefault,
		icon: <InfoIcon />,
	},
	{
		title: t('entry_point_label_construction_projects'),
		href: urls.constructionProjects,
		color: Color.TertiaryDefault,
		icon: <ConstructionIcon />,
	},
	{
		title: t('entry_point_label_media_library'),
		href: urls.mediaLibrary,
		color: Color.AccentDefault,
		icon: <AttachFileIcon />,
	},
	{
		title: t('entry_point_label_stay_connected'),
		href: urls.stayConnected,
		color: Color.PrimaryDark,
		icon: <BreakingNewsIcon />,
	},
];
